import { render, staticRenderFns } from "./Format.vue?vue&type=template&id=0f758dae&scoped=true&"
import script from "./Format.vue?vue&type=script&lang=js&"
export * from "./Format.vue?vue&type=script&lang=js&"
import style0 from "./Format.vue?vue&type=style&index=0&id=0f758dae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f758dae",
  null
  
)

export default component.exports